export default {
  'logo.name': 'BasetaoSheet',
  'logo.tagline': 'Centre de ressources',

  'meta.title': 'Tableur Basetao : produits, vendeurs & guides d’achat',
  'meta.description': 'Explorez les ressources du tableur Basetao, les trouvailles produits, les guides vendeurs, les conseils QC, les infos de livraison et les guides d’achat.',

  'nav.spreadsheet': 'Tableur',
  'nav.home': 'Accueil',
  'nav.guide': "Guide d'achat",
  'nav.guides': 'Guides',
  'nav.products': 'Produits',
  'nav.sellers': 'Vendeurs',
  'nav.qc': 'Contrôle qualité',
  'nav.shipping': 'Livraison',
  'nav.reviews': 'Avis',
  'nav.safety': 'Sécurité',
  'nav.cta': 'Explorer le tableur',

  'hero.eyebrow': 'LE CENTRE DE RESSOURCES DU TABLEUR BASETAO',
  'hero.title': 'Tableur Basetao — Trouvez produits, vendeurs et guides d’achat plus vite',
  'hero.subtitle': 'Explorez des ressources organisées du tableur Basetao, des trouvailles produits, des infos vendeurs, des guides de contrôle qualité, des conseils de livraison et des tutoriels pratiques — tout au même endroit.',
  'hero.ctaPrimary': 'Tableur Basetao',
  'hero.ctaSecondary': 'Acheter maintenant',
  'hero.dropdownLabel': 'Parcourir une catégorie',
  'hero.dropdownPlaceholder': 'Choisissez une catégorie de produits…',
  'hero.trust': 'Ressource indépendante · Guides à jour · Recherche produits & vendeurs · Contrôle qualité & livraison',

  'value.title': 'Tout ce qu’il faut pour naviguer sur Basetao',
  'value.subtitle': 'Un point de départ clair et organisé pour mieux découvrir des produits.',
  'value.c1.title': 'Tableur Basetao',
  'value.c1.desc': 'Découvrez des ressources organisées et apprenez à évaluer les informations sur les produits et les vendeurs.',
  'value.c2.title': 'Guides produits & vendeurs',
  'value.c2.desc': 'Comparez produits, vendeurs, prix et les signaux importants avant de commander.',
  'value.c3.title': 'Contrôle qualité',
  'value.c3.desc': 'Comprenez les photos QC, les indicateurs de qualité et ce qu’il faut vérifier avant de commander.',
  'value.c4.title': 'Livraison & sécurité',
  'value.c4.desc': 'Comparez les options et coûts de livraison, et apprenez à repérer les risques et annonces suspectes.',

  'categories.title': 'Parcourir les catégories de produits',
  'categories.subtitle': 'Accédez directement à une catégorie de la boutique principale et explorez des trouvailles organisées.',
  'categories.open': 'Ouvrir la catégorie',

  'about.eyebrow': 'QU’EST-CE QU’UN TABLEUR BASETAO ?',
  'about.title': 'Une façon plus intelligente de trouver produits et vendeurs',
  'about.body1': 'Un tableur Basetao est un document partagé et organisé qui rassemble des liens produits, des détails vendeurs, des prix et des notes issues de l’écosystème d’agent d’achat Basetao. Au lieu de faire défiler des annonces sans fin, les acheteurs utilisent ces tableurs pour comparer les options côte à côte et comprendre exactement ce qu’ils achètent.',
  'about.body2': 'La plupart des tableurs sont organisés par catégorie — chaussures, hoodies, t-shirts, vestes, sacs et plus — et chaque ligne pointe généralement vers un produit ou un vendeur avec un contexte supplémentaire comme le prix, des notes de taille et des remarques QC.',
  'about.body3': 'Comme ces documents sont mis à jour régulièrement, ils constituent un raccourci pratique pour découvrir de nouveaux articles et des vendeurs de confiance sans passer des heures sur les places de marché.',
  'about.list1': 'Liens produits sélectionnés',
  'about.list2': 'Signaux vendeurs & prix',
  'about.list3': 'Mises à jour régulières',

  'how.title': 'Comment utiliser un tableur Basetao',
  'how.subtitle': 'Quatre étapes simples pour tirer le meilleur de n’importe quel tableur.',
  'how.s1.title': 'Découvrir',
  'how.s1.desc': 'Trouvez des produits et catégories pertinents qui correspondent à votre recherche.',
  'how.s2.title': 'Comparer',
  'how.s2.desc': 'Examinez les informations produit, vendeur et prix côte à côte.',
  'how.s3.title': 'Vérifier',
  'how.s3.desc': 'Contrôlez les liens, les signaux vendeurs et les informations QC disponibles.',
  'how.s4.title': 'Décider',
  'how.s4.desc': 'Utilisez ces informations pour prendre votre propre décision éclairée.',

  'topics.title': 'Ressources Basetao populaires',
  'topics.subtitle': 'Des guides et ressources pour acheter avec plus de confiance.',
  'topics.cardTitle': 'Guide du tableur Basetao',
  'topics.cardDesc': 'Apprenez ce qu’est un tableur Basetao, comment le lire et l’utiliser pour trouver de meilleurs produits et vendeurs.',
  'topics.readMore': 'Lire le guide',
  'topics.moreComing': 'Plus de guides bientôt',
  'guide.notFound': 'Ce guide est introuvable.',

  'faq.title': 'FAQ sur le tableur Basetao',
  'faq.q1': 'Qu’est-ce qu’un tableur Basetao ?',
  'faq.a1': 'C’est un document organisé qui rassemble des liens produits, des infos vendeurs, des prix et des notes de l’écosystème Basetao, pour comparer et découvrir plus facilement.',
  'faq.q2': 'Le tableur est-il gratuit ?',
  'faq.a2': 'Les ressources du tableur sont informatives. Vérifiez toujours la source et les liens avant d’acheter.',
  'faq.q3': 'À quelle fréquence le tableur est-il mis à jour ?',
  'faq.a3': 'Cela dépend de la source. Les tableurs fiables sont généralement actualisés régulièrement à mesure que produits et vendeurs sont ajoutés.',
  'faq.q4': 'Puis-je faire confiance à tous les vendeurs listés ?',
  'faq.a4': 'Aucune ressource ne peut garantir un vendeur. Utilisez plusieurs signaux — avis, photos QC et infos de livraison — avant de décider.',
  'faq.q5': 'Quelles catégories sont généralement incluses ?',
  'faq.a5': 'Les catégories courantes incluent chaussures, hoodies, t-shirts, vestes, pantalons, couvre-chefs, ensembles, sous-vêtements, maillots, accessoires, sacs, ceintures, parfums et plus.',

  'cta.title': 'Prêt à explorer les ressources du tableur Basetao ?',
  'cta.subtitle': 'Parcourez les derniers guides, ressources produits et infos d’achat dans un hub organisé.',
  'cta.button': 'Explorer le tableur Basetao',

  'footer.tagline': 'Un centre de ressources indépendant pour les guides du tableur Basetao, les trouvailles produits et les infos d’achat.',
  'footer.disclaimer': 'Ce site est une ressource d’information indépendante. Il n’est ni affilié ni approuvé par Basetao.',
  'footer.navTitle': 'Explorer',
  'footer.resourceTitle': 'Ressources',
  'footer.copyright': 'Tous droits réservés.',

  'cat.shoes': 'Chaussures',
  'cat.hoodies': 'Hoodies / Pulls',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Vestes',
  'cat.pants': 'Pantalons / Shorts',
  'cat.headwear': 'Couvre-chefs',
  'cat.sets': 'Ensembles',
  'cat.underwear': 'Sous-vêtements',
  'cat.jersey': 'Maillots',
  'cat.accessories': 'Accessoires',
  'cat.bags': 'Sacs',
  'cat.belts': 'Ceintures',
  'cat.perfumes': 'Parfums',
  'cat.other': 'Autres articles',
};